import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const inailcode = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/inail-code',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'inailcode' }
    ),
    { }
  )
)()

export { inailcode, TYPES }
